export function formatPublicListingPrice(listing) {
  if (listing?.price == null) {
    return "Price on request";
  }

  const currency = listing.currency || "COP";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(listing.price);
  } catch {
    return `${listing.price} ${currency}`;
  }
}

export function formatPublicLocation(listing) {
  const parts = [listing?.neighborhood, listing?.municipality].filter(Boolean);
  return parts.join(", ") || "Location available on request";
}

export function listingTypeLabel(listingType) {
  if (!listingType) {
    return null;
  }
  const normalized = String(listingType).toLowerCase();
  if (normalized === "sale") {
    return "For sale";
  }
  if (normalized === "rent") {
    return "For rent";
  }
  return listingType;
}
